<template>
  <div class="guide-slider">
    <div class="steps-container">
      <div
        v-for="(image, i) in stepImages"
        :key="i"
        class="steps fade"
        ref="steps"
      >
        <div class="page">{{ i + 1 }} / {{ stepImages.length }}</div>
        <div class="image" :style="`background-image: url(${image})`" />
        <div class="caption">{{ stepCaptions[i] }}</div>
      </div>
      <div v-if="!stepImages.length">
        <div class="caption">
          {{ loading ? "Loading guide..." : "No guide loaded" }}
        </div>
      </div>
      <a class="prev" @click="prevStep">❮</a>
      <a class="next" @click="nextStep">❯</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    route: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    stepImages: [],
    stepCaptions: [],
    currentStep: 1,
    loading: false,
  }),
  mounted() {
    this.fetchSteps();
  },
  methods: {
    async fetchSteps() {
      if (!this.route) return;
      this.stepImages = [];
      this.stepCaptions = [];
      this.currentStep = 1;
      try {
        this.loading = true;
        const response = await fetch(
          `https://api.service.sitevitals-beta.com/api/v1/external/steps?topic_code=${this.route}`
        ).then((response) => response.json());
        const steps = response.data;
        const images = [];
        const captions = [];
        steps.forEach((v) => {
          images.push(v.attributes.path);
          captions.push(v.attributes.name);
        });
        this.stepImages = images;
        this.stepCaptions = captions;
        this.$nextTick(() => {
          this.showStep(1);
        });
      } catch (err) {
        throw err;
      } finally {
        this.loading = false;
      }
    },
    nextStep() {
      let n = this.currentStep + 1;
      this.showStep(n > this.stepImages.length ? 1 : n);
    },
    prevStep() {
      let n = this.currentStep - 1;
      this.showStep(n < 1 ? this.stepImages.length : n);
    },
    showStep(n) {
      if (this.$refs.steps && this.$refs.steps[n - 1]) {
        this.$refs.steps.forEach((v) => (v.style.display = "none"));
        this.$refs.steps[n - 1].style.display = "block";
        this.currentStep = n;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.guide-slider {
  height: 600px;

  .steps-container {
    height: inherit;
    position: relative;
    max-width: 1070px;
    margin: auto;
    border-radius: 6px;
    border: 1px solid #eee;
  }

  .steps {
    display: none;
    height: inherit;
  }

  .image {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    background-size: 100%;
    background-position: 0;
  }

  .prev,
  .next {
    cursor: pointer;
    position: absolute;
    top: 50%;
    width: auto;
    padding: 16px;
    margin-top: -22px;
    color: white;
    font-weight: bold;
    font-size: 18px;
    border-radius: 0 3px 3px 0;
    user-select: none;
    background-color: rgba(0, 0, 0, 0.8);
  }

  .next {
    right: 0;
    border-radius: 3px 0 0 3px;
  }

  .page {
    color: #eee;
    font-size: 12px;
    padding: 8px 12px;
    position: absolute;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }

  .caption {
    color: #eee;
    font-size: 15px;
    padding: 8px 12px;
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.5);
  }

  /* Fading animation */
  .fade {
    animation-name: fade;
    animation-duration: 1.5s;
  }

  @keyframes fade {
    from {
      opacity: 0.4;
    }
    to {
      opacity: 1;
    }
  }
}
</style>
